export const metaData = {
	data() {
		return {
			meta: {}
		}
	},
	methods: {
		metaUnique(obj){
			if(!obj) return;
			return '<span class="total-key">Unique</span><span class="total-value">' + obj.unique + '</span>';
		},



		metaValues(obj){
			if(!obj) return;

			if(obj.unique){
				return '<span class="total-key">Unique</span><span class="total-value">' + obj.unique + '</span>';
			}

			var html = '<span class="total-key">Total</span>' +
				'<span class="total-value">' + obj.total + '</span>' +
				'<span class="total-key">Count</span>' +
				'<span class="total-value">' + obj.count + '</span>' +
				'<span class="total-key">Avg</span>' +
				'<span class="total-value">' + obj.average + '</span>';
			return html;
		},


		metaDollar(obj){
			if(!obj) return;

			var html = '<span class="total-key">Total</span>' +
				'<span class="total-value">' + obj.total + '</span>' +
				'<span class="total-key">Count</span>' +
				'<span class="total-value">' + obj.count + '</span>' +
				'<span class="total-key">Avg</span>' +
				'<span class="total-value">' + obj.average + '</span>';
			return html;

		},
	},

}






// WEBPACK FOOTER //
// ./src/mixins/metaData.js